import { call, put, takeLatest } from 'redux-saga/effects';
import { AdminCompetences } from 'services/api';
import {
  getAdminCompetences,
  createCompetence,
  createCompetenceSuccess,
  createCompetenceFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';
import { clearFilter } from 'components/CompetenceFilter/actions';

function* createCompetenceSaga({ payload }) {
  try {
    const data = yield call(AdminCompetences.createCompetence, {
      competence: payload.values,
    });
    yield put(createCompetenceSuccess(data));
    yield put(getAdminCompetences({ locale: payload.locale }));
    yield put(clearFilter());
    yield put(
      notificationActions.addNotification([
        {
          type: 'success',
          message: { code: 'created', resource: 'competence' },
        },
      ])
    );
  } catch (e) {
    yield put(createCompetenceFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(createCompetence, createCompetenceSaga);
